/* eslint-disable camelcase, import/extensions, import/no-self-import */
import axios from 'axios';
import { base_url as baseUrl } from 'env.js';
import { getHeaders } from 'store/common/common.js';
/* eslint-enable camelcase, import/extensions, import/no-self-import */

axios.defaults.baseURL = baseUrl;

// Define an array of route paths you want to exclude from the loading indicator
const excludedPaths = ['resources', 'v2', 'importFromIntegration'];
const excludeLocations = ['serviceCall/create'];
const requiredLoaderPaths = ['serviceCall', 'payments', 'subscriptions'];

axios.interceptors.request.use(
  (options) => {
    const currentPath = window.location.pathname;

    const excludedPathsBoolean = !excludedPaths.some((path) =>
      options.url.includes(path),
    );

    const excludeLocationBoolean = !excludeLocations.some((path) =>
      currentPath.includes(path),
    );

    const currentPathsBoolean = requiredLoaderPaths.some((path) =>
      currentPath.includes(path),
    );

    if (excludedPathsBoolean && currentPathsBoolean && excludeLocationBoolean) {
      document.body.classList.add('loading-indicator');
    }

    return { ...options, headers: getHeaders() };
  },
  (error) => {
    setTimeout(() => {
      document.body.classList.remove('loading-indicator');
    }, 1000);
    return Promise.reject(error);
  },
);

const SSANDSI_URL_PATTERN = /^\/?ssandsi\//;

axios.interceptors.response.use(
  (response) => {
    setTimeout(() => {
      document.body.classList.remove('loading-indicator');
    }, 1000);
    return response;
  },
  (error) => {
    setTimeout(() => {
      document.body.classList.remove('loading-indicator');
    }, 1000);

    if (error.response?.status === 440) {
      window.location.href = '/';
    } else if (
      error.response?.status === 401 &&
      (error.response?.data?.message?.includes('Token has expired') ||
        (error.response?.data?.code === 'auth.unauthenticated' &&
          SSANDSI_URL_PATTERN.test(error.config?.url ?? '')))
    ) {
      window.location.href = '/';
    }

    return Promise.reject(error);
  },
);

window.axios = axios;

export default axios;
